import { render, staticRenderFns } from "./ClienteCob.vue?vue&type=template&id=05dd70a6&"
import script from "./ClienteCob.vue?vue&type=script&lang=js&"
export * from "./ClienteCob.vue?vue&type=script&lang=js&"
import style0 from "./ClienteCob.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports